module.exports = __webpack_public_path__ + "img/Pontuei_Logo_1.5f04d3d7.png";